var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.variant === 'beta')?_c(_vm.betaComponent,_vm._b({tag:"component"},'component',_vm.betaProps,false)):(_vm.variant === 'classic')?_c(_vm.classicComponent,{tag:"component"}):_c('div',{staticStyle:{"min-height":"60vh"}})}
var staticRenderFns = []

export { render, staticRenderFns }